Directives.ParticipantInfo = function ParticipantInfo() {

    // @ngInject
    function ParticipantInfoDirectiveControllerFunc($scope, $injector, AppStates, UsersManager) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ProjectParticipantInfoDirectiveControllerFunc';

        this.AppStates = AppStates;

        this.currentUser = UsersManager.getCurrUser();
    }

    var ParticipantInfoDirectiveController = Class(Controllers.BaseController, {
        constructor: ParticipantInfoDirectiveControllerFunc,
    });

    return {
        scope: {
            participant : '=',
            workspace: '=',
            close: '&',
            allowActions: '='
        },
        templateUrl: 'angular/app/modules/core/features/workspace/project_participant_info/project_participant_info.html',
        controller: ParticipantInfoDirectiveController,
        controllerAs: 'participantInfoVm',
        bindToController: true
    };
};
